export default __webpack_public_path__ + "static/media/about-us-image-rev.c6a5a569.jpg";